// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--14ef8","testimonialsWrapper":"styles-module--testimonialsWrapper--ac633"};